import React, { useEffect, useState } from "react";
import { Badge, Button, Spinner } from "reactstrap";
import { useFormData } from "./FormDataContext"; // Import your context hook
import {
  Collapse as AntCollapse,
  Descriptions,
  Popover,
  Timeline,
  Table,
  List,
  Modal,
  Empty,
} from "antd";
import axios from "axios";
import { ApprovalData, Material } from "./types"; // Import your types
import { nanoid } from "nanoid";
import dayjs from "dayjs";
import { PaperClipOutlined, DownloadOutlined } from "@ant-design/icons";
import budgetApis from "../../../api/master/budget";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import rolesApi from "../../../api/master/roles";
import { formatCurrency } from "../../../utils/Utils";
import { render } from "@testing-library/react";
import { submitBudgetData } from "./budgetSubmissionHelper";

const { Panel } = AntCollapse;

const BudgetPreview: React.FC<{ prev: () => void }> = (props) => {
  const navigate = useNavigate();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableSaveAsDraft, setDisableSaveAsDraft] = useState(false);
  const { formData } = useFormData();
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [roles, setRoles] = useState<any>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  const fetchApprovalHierarchyUsersByModuleId = async (moduleID: number, siteId: number) => {
    console.log("formData.site", formData.budgetHeader.site);
    console.log(formData, "formData");

    try {
      const res = await rolesApi.fetchHierarchyUsersByModuleId(
        moduleID,
        // Number(formData.budgetHeader.site)
        siteId
      );
      if (!res) return;
      const { data, status } = res;
      if (status) {
        setRoles(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchModuleConfig = async () => {
    try {
      const res = await rolesApi.getModuleConfig();
      let moduleID: number | undefined;

      const procureToPayCategory = res?.data?.find(
        (category: any) => category.category === "ProcureToPay"
      );


      if (procureToPayCategory && procureToPayCategory.modules) {
        const budgetModule = procureToPayCategory.modules.find(
          (module: any) => module.moduleName === "Budget"
        );


        if (budgetModule) {
          moduleID = budgetModule.moduleID;
        }
      }


      if (moduleID && formData.budgetHeader?.site) {
        await fetchApprovalHierarchyUsersByModuleId(moduleID, Number(formData.budgetHeader.site));
      } else {
        console.warn("Module ID or Site ID is missing", {
          moduleID,
          site: formData.budgetHeader?.site
        });
        setRoles([]);
      }
    } catch (err) {
      console.error("Error fetching module config:", err);
      setRoles([]);
    }
  };

  const handleSubmit = async (status: string = "PENDING") => {
    if (status === "DRAFT") {
      setDisableSaveAsDraft(true);
    } else {
      setDisableSubmit(true);
    }

    try {
      await submitBudgetData({
        formData,
        status,
        navigate,
      });
    } catch (error) {
      console.error("Error submitting budget:", error);
    } finally {
      setDisableSubmit(false);
      setDisableSaveAsDraft(false);
    }
  };

  const handleExpand = (expanded: boolean, record: any) => {
    console.log("record", record, expanded);
    if (expanded) {
      // Add the record's key to the expandedRowKeys array
      setExpandedRowKeys((prevKeys) => [...prevKeys, record.key]);
    } else {
      // Remove the record's key from the expandedRowKeys array
      setExpandedRowKeys((prevKeys) =>
        prevKeys.filter((key) => key !== record.key)
      );
    }
  };

  const requiredDocsContent = formData?.budgetHeader?.requiredDocs ? (
    <Table
      dataSource={formData.budgetHeader.requiredDocs.map(
        (doc: any, index: number) => ({
          key: index + 1,
          sNo: index + 1,
          documentName: doc.documentName,
          mandatory: doc.mandatory ? "Yes" : "No",
        })
      )}
      columns={[
        {
          title: "S.No",
          dataIndex: "sNo",
          key: "sNo",
        },
        {
          title: "Document Name",
          dataIndex: "documentName",
          key: "documentName",
        },
        {
          title: "Mandatory to Upload",
          dataIndex: "mandatory",
          key: "mandatory",
        },
      ]}
      pagination={false}
      size="small"
      style={{ minWidth: "200px" }}
    />
  ) : null;

  useEffect(() => {
    console.log("HIIII", formData);
    fetchModuleConfig();
  }, []);

  const columns = [
    {
      title: "Budget Line",
      dataIndex: "budgetLineName",
      key: "budgetLineName",
      fixed: "left" as const,
      width: 120,
    },
    {
      title: "Budget Line Description",
      dataIndex: "lineDescription",
      key: "lineDescription",
      // fixed: 'left' as const,
      width: 200,
    },
    {
      title: "Budget For",
      dataIndex: "budgetFor",
      key: "budgetFor",
      width: 150,
      render: (text: any) => text || "Not Available",
    },
    {
      title: "Budget Value",
      dataIndex: "budgetValue",
      key: "budgetValue",
      width: 150,
      render: (text: any) => {
        if (text === null || text === undefined) return "";
        const textStr = typeof text === "string" ? text : text.toString();
        const value = parseFloat(textStr.replace(/,/g, ""));
        return isFinite(value) ? formatCurrency(value, "INR") : textStr;
      },
    },
    {
      title: "Planned Start Date",
      dataIndex: "startDate",
      key: "startDate",
      width: 200,
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Contractor",
      dataIndex: "contractorName",
      key: "contractorName",
      width: 150,
      render: (text: any) => text || "-",
    },
    {
      title: "Planned End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Bill Of Material (BOM)",
      dataIndex: "bom",
      key: "bom",
    },
    {
      title: "BOM Allocation",
      dataIndex: "allocation",
      key: "allocation",
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      width: 150,
    },
  ];

  const ApprovalTimelineContent = () => {
    const approvalsData = JSON.parse(formData?.budgetHeader?.approvalsData);
    console.log("approvalsData", approvalsData);
    const isStrictMode = formData?.isStrictApproval || false;
    if (
      !approvalsData ||
      approvalsData?.data?.length === 0 ||
      formData?.budgetHeader?.approvalRequired == "N"
    )
      return <Badge color="outline-danger">No</Badge>;
    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const Role = roles.find(
                (role: any) => role?.roleID == approval?.roleId
              );
              return (
                <Timeline.Item key={index}>
                  {
                    Role?.employees?.find((e: any) => e?.id == approval?.userId)
                      ?.name
                  }
                  <div className="designation">{Role?.roleName}</div>
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer"
        }}>
          <span
            style={{
              color: "#2263b3",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>
          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  return (
    <div className="content clearfix">
      <AntCollapse defaultActiveKey={["1"]}>
        <Panel header="General Details" key="1">
          <Descriptions title="" className="custom-description-title">
            <Descriptions.Item label="Budget Name">
              {formData?.budgetHeader?.budgetName}
            </Descriptions.Item>
            <Descriptions.Item label="Planned Start Date">
              {dayjs(formData?.budgetHeader?.startDate).format("DD-MMM-YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Planned End Date">
              {dayjs(formData?.budgetHeader?.endDate).format("DD-MMM-YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Budget Description">
              <Popover
                content={
                  <div>
                    <p>{formData?.budgetHeader?.description}</p>
                  </div>
                }
                title={"Description"}
              >
                {formData?.budgetHeader?.description?.length > 20 ? (
                  <span
                    style={{
                      color: "#2263b3",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    {formData?.budgetHeader?.description?.substring(0, 20)}
                    ...
                  </span>
                ) : (
                  formData?.budgetHeader?.description
                )}
              </Popover>
              {/* {formData?.budgetHeader?.description} */}
            </Descriptions.Item>
            <Descriptions.Item label="Site Name">
              {formData.budgetHeader?.siteName}
            </Descriptions.Item>
            <Descriptions.Item label="Line Of Business (LOB)">
              {formData.budgetHeader?.lob}
            </Descriptions.Item>
            <Descriptions.Item label="Cost Center">
              {formData.budgetHeader?.costCenterName}
            </Descriptions.Item>
            <Descriptions.Item label="Approvals">
              {/* {formData.budgetHeader?.approvalRequired === "Y" ? (
                <Popover
                  content={approvalTimelineContent}
                  title={
                    <span style={{ color: "#2263b3" }}>Approval Hierarchy</span>
                  }
                >
                  <span
                    style={{
                      color: "#2263b3",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Yes
                  </span>
                </Popover>
              ) : (
                "No"
              )} */}
              {formData?.budgetHeader?.approvalsData && (
                <ApprovalTimelineContent />
              )}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Additional Charges">
              {" "}
              {formData.budgetHeader?.additionalCharges}
            </Descriptions.Item>
            <Descriptions.Item label="Auto Release">
              {formData.budgetHeader?.autoRelease === "Y" ? "Yes" : "No"}
            </Descriptions.Item> */}
          </Descriptions>
        </Panel>
        <Panel header="Materials" key="2">
          <Table
            columns={columns}
            dataSource={formData.materialsData || []}
            scroll={{ x: "max-content" }}
            expandable={{
              expandedRowRender: (record: any) => {
                if (record.bom == "Y") {
                  return (
                    <div>
                      <div>
                        <p style={{ margin: 0 }}>
                          <strong>BOM Lines</strong>
                        </p>
                        <div className="mt-3">
                          <Table
                            className="customTable"
                            columns={[
                              {
                                title: "Category",
                                dataIndex: "categoryName",
                                key: "categoryName",
                                fixed: "left" as const,
                                width: 130,
                              },
                              {
                                title: "Material Name",
                                dataIndex: "materialName",
                                key: "materialName",
                                fixed: "left" as const,
                                width: 130,
                              },
                              {
                                title: "Qty",
                                dataIndex: "quantity",
                                key: "quantity",
                                fixed: "left" as const,
                                width: 130,
                              },
                              {
                                title: "UOM",
                                dataIndex: "uomName",
                                key: "uomName",
                                width: 130,
                              },
                              {
                                title: "Allocation",
                                dataIndex: "allocated",
                                key: "allocated",
                                width: 130,
                                render: (text: any) => {
                                  if (record.allocation === "value") {
                                    const value = parseFloat(
                                      text.toString().replace(/,/g, "")
                                    );

                                    // Check if the parsed value is a valid number
                                    if (!isNaN(value)) {
                                      // Format the value as currency
                                      return formatCurrency(value, "INR");
                                    } else {
                                      return text; // Return original value if invalid
                                    }
                                  } else {
                                    return text + "%";
                                  }
                                },
                              },
                            ]}
                            dataSource={record.bomLines?.map((item: any) => ({
                              ...item,
                              key: item?.id,
                            }))}
                            scroll={{ x: 1000 }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              },
              expandedRowKeys,
              onExpand: handleExpand,
              rowExpandable: (record: any) => record.bom === "Y", // Conditionally show expandable icon
            }}
            bordered
            size="small"
            pagination={false}
            locale={{ emptyText: "No materials added" }}
          />
        </Panel>
        <Panel header="Other Information" key="3">
          <Descriptions title="" className="custom-description-title">
            <Descriptions.Item label="Instructions">
              <span
                style={{
                  color: "#2263b3",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setInstructionsVisible(true)}
              >
                View Instructions
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="Terms and Conditions">
              <span
                style={{
                  color: "#2263b3",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setTermsVisible(true)}
              >
                View Terms and Conditions
              </span>
            </Descriptions.Item>
            {formData.docKeys.fileList?.length > 0 && (
              <Descriptions.Item label="">
                <div>
                  <div className="">
                    Attachments &nbsp;
                    <PaperClipOutlined />
                  </div>
                  <div>
                    {formData.docKeys.fileList?.map(
                      (attachment: any, index: number) => (
                        <div
                          key={index}
                          className="w-100 d-flex justify-content-between"
                        >
                          <div>
                            <strong>{index + 1}.</strong>
                            &nbsp;
                            {attachment.name}
                            &nbsp; &nbsp; &nbsp; &nbsp;
                          </div>
                          <div>
                            <a
                              href={URL.createObjectURL(
                                attachment?.originFileObj
                              )}
                              download={attachment.name}
                              style={{ color: "black", fontSize: "18px" }}
                            >
                              <DownloadOutlined />
                            </a>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </Descriptions.Item>
            )}
          </Descriptions>
        </Panel>
      </AntCollapse>
      <Modal
        title="Instructions"
        visible={instructionsVisible}
        footer={null}
        onCancel={() => setInstructionsVisible(false)}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        {formData?.instructions ? (
          <pre>{formData?.instructions}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No instructions provided for this Budget" />
          </div>
        )}
        {/* <div
          dangerouslySetInnerHTML={{
            __html: formData?.instructions || "",
          }}
        /> */}
      </Modal>
      <Modal
        title="Terms and Conditions"
        visible={termsVisible}
        footer={null}
        onCancel={() => setTermsVisible(false)}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        {formData?.termsAndConditions ? (
          <pre>{formData?.termsAndConditions}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No terms and conditions provided for this purchase order" />
          </div>
        )}
      </Modal>
      <div className="actions clearfix">
        <ul>
          <li>
            {disableSubmit ? (
              <Button color="primary" type="button">
                <Spinner size="sm" color="light" />
              </Button>
            ) : (
              <Button color="primary" onClick={() => handleSubmit("PENDING")}>
                Submit
              </Button>
            )}
          </li>
          <li>
            <Button
              color="secondary"
              onClick={props.prev}
              className="btn-dim btn btn-secondary"
            >
              Previous
            </Button>
          </li>
          <li>
            {disableSaveAsDraft ? (
              <Button color="secondary" type="button">
                <Spinner size="sm" color="light" />
              </Button>
            ) : (
              <Button color="secondary" onClick={() => handleSubmit("DRAFT")}>
                Save as Draft
              </Button>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default React.memo(BudgetPreview);
